import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { validateOrder } from '../../thunks/validateOrder';
import { resetOrder } from '../../actions/currentOrder';

const initialState = false;

const slice = createSlice({
  name: '$validationInProgress',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(validateOrder.pending, (_state, _action) => {
        return true;
      })
      .addCase(resetOrder, (_state, _action) => {
        return initialState;
      })
      .addMatcher(
        isAnyOf(validateOrder.pending, validateOrder.rejected),
        (_state, _action) => {
          return false;
        },
      );
  },
});

export default slice.reducer;
